// extracted by mini-css-extract-plugin
export default {"logoContainer":"logo_logoContainer__sWvVu"};